import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface appState {
    showLoginSuccessModal: boolean;
    showLoader: boolean;

}

const initialState: appState = {
    showLoginSuccessModal: false,
    showLoader: false,
}

const appStateSlice = createSlice({
    name: "app-state",
    initialState,
    reducers: {
        changeLoginModalState: (state, action: PayloadAction<boolean>) => {
            state.showLoginSuccessModal = action.payload;
        },

        changeLoaderState: (state, action: PayloadAction<boolean>) => {
            state.showLoader = action.payload;
        },
    },
});

export const { changeLoginModalState, changeLoaderState } = appStateSlice.actions;
export default appStateSlice.reducer;